export default __webpack_public_path__ + "static/media/orders_active.1ad75fa8.svg";